<template>
	<view class="constant">
		<view class="wrap flexCenter" @click="handleCall">
			<image src="../static/warn.png" mode=""></image>
			<view class="text">
				一键报警
			</view>
		</view>
	</view>
</template>

<script>
	import {
		mapGetters
	} from "vuex"
	export default{
		data() {
			return{
				
			}
		},
		computed: {
			...mapGetters(['orderIdList'])
		},
		onLoad() {
			
		},
		
		methods:{
			handleCall(){
				let that = this
				uni.showModal({
					title: '一键报警',
					content: '报警',
					cancelText: '否',
					confirmText: '是',
					success: function(res) {
						if (res.confirm) {
							// this.$store.dispatch('callPolice')
							that.$store.dispatch("callPolice")
				
						} else if (res.cancel) {
							console.log('用户点击取消');
						}
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.flexCenter{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.wrap{
		position: fixed;
		bottom: 150upx;
		right: 30upx;
		flex-direction: column;
		width: 120upx;
		height: 120upx;
		border-radius: 50%;
		border: 1upx solid #ff5558;
		background-color: #F6D6D6;
		image{
			width: 34upx;
			height: 36upx;
			padding-bottom: 6upx;
		}
		.text{
			font-size: 22upx !important;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 600;
			color: #E02020;
		}
	}
</style>
